import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React from "react";

const DialogConfirmInvoiceDiscount = ({
  visible,
  setVisible,
  handleSubmit,
}) => {
  return (
    <Dialog
      header="Lập hóa đơn Chiết khấu thương mại"
      visible={visible}
      onHide={() => setVisible(false)}
      style={{ width: "600px" }}
      footer={() => (
        <div className="flex justify-content-end">
          <Button
            label="Hủy bỏ"
            onClick={() => setVisible(false)}
            className="p-button-text p-button-sm"
          />
          <Button
            label="Lập hóa đơn, bỏ qua bước lập bảng kê"
            onClick={() => handleSubmit(false)}
            className="p-button-outlined p-button-sm"
          />
          <Button
            label="Lập bảng kê đính kèm"
            onClick={() => handleSubmit(true)}
            className="p-button-sm"
          />
        </div>
      )}
    >
      <div>
        <p>
          Căn cứ Điểm b, Khoản 5, Điều 10, Thông tư 91/2026/TT-BTC: Trường hợp
          việc chiết khấu thương mại căn cứ vào số lượng, doanh số hàng hóa,
          dịch vụ được lập hóa đơn điều chỉnh kèm theo bảng kê các số hóa đơn
          cần điều chỉnh, số tiền, tiền thuế điều chỉnh. Bảng kê được lưu tại
          đơn vị và xuất trình khi cơ quan thuế hoặc cơ quan nhà nước có thẩm
          quyền yêu cầu.
        </p>
        <div
          style={{ background: "#E7F3FF" }}
          className="px-4 py-2 border-round-lg mb-2"
        >
          <p className="font-bold text-xl">
            Thao tác tạo hóa đơn chiết khấu thương mại gồm 2 bước sau:
          </p>
          <p>
            Bước 1: Lập bảng kê chứa danh sách hóa đơn thỏa mãn chương trình
            Chiết khấu
          </p>
          <p>
            Bước 2: Tạo hóa đơn Điều chỉnh gắn với Số bảng kê, Ngày bảng kê đã
            lập
          </p>
          <p>
            &emsp;&emsp;&emsp;&emsp;(Tính chất dòng hàng là Hàng hóa dịch vụ,
            Tổng tiền là số dương)
          </p>
        </div>
        <p>Bạn có muốn lập bảng kê đính kèm không?</p>
      </div>
    </Dialog>
  );
};

export default DialogConfirmInvoiceDiscount;
